# Создаем Application
window.App = require 'config/app'

# Устанавливаем константы
window.RECURRENCE_TYPES = ['new', 'active', 'returned', 'cold', 'dead']
window.RECURRENCE_LABELS = ['Новые', 'Активные', 'Вернувшиеся', 'Остывшиe', 'Потерянные']
# todo i18n
window.RECURRENCE_COLORS = [
  '#FF9180',
  '#2ECC71',
  '#FBC400',
  '#8CB9E0',
  '#686DAD'
]
window.ORDER_STATUSES   = ['undo', 'complete', 'pending', 'delivery', 'preparing', 'prepared']
window.ORDER_SOURCES    = ['delivery_club', 'external_site', 'external_site_mobile', 'marketplace', 'marketplace_mobile', 'board', 'mobile_application_ios', 'mobile_application_android', 'foodfox', 'obed_ru', 'broniboy', 'iiko', 'chibbis', 'glovo', 'vk', 'sbermarket', 'external_aggregator', 'yandex_lavka']
window.SORTING_PARAMS   = ['orders_count', 'average_check', 'bonus_count', 'created_at']
window.DELIVERY_TYPES   = ['takeaway', 'delivery', 'dine_in']


# Подгружаем роутер
require 'config/router'

window.require
  .list()
  .forEach (module) ->
    switch
      # Загружаем темплейты в Ember.TEMPLATES[]
      when /^templates\//.test(module)
        normalizedName = module
          .replace(/^templates\//, '')
          .replace(/\.[^.]*$/, '')

        Ember.TEMPLATES[normalizedName] = require(module)

      # Регистрируем сервисы
      when /^services\//.test(module)
        normalizedName = module
          .replace(/^services\//, '')
          .replace(/\.[^.]*$/, '')

        className = "#{normalizedName}-service".classify()
        App[ className ] = require(module)


# Load all modules in order automagically. Ember likes things to work this
# way so everything is in the App.* namespace.
folderOrder = [
  'locales', 'services','initializers', 'mixins', 'adapters', 'serializers', 'transforms', 'routes',
  'models', 'views', 'controllers', 'helpers', 'templates', 'components', 'services',
  'utils/patches'
]

folderOrder.forEach (folder) ->
  # Go through the prefixes in order and require them
  window.require.list().filter((module) ->
    new RegExp("^#{folder}/").test(module)
  ).forEach((module) -> require(module))

document.head.insertAdjacentHTML('afterbegin', '<link rel="stylesheet" href="https://cdn.ckeditor.com/ckeditor5/44.1.0/ckeditor5.css" />')
